export default {
  sendMoneyUserInfo: {
    status: '',
    reason: '',
    username: '',
  },
  phone: '',
  loadingStatus: '',
  validSalesCode: false,
  oomFlowEligibility: false,
  qrisUserInfo: {},
  qrisBlueBoxFirstDate: '',
  hasPIN: false,
};
